module.exports = __webpack_public_path__ + "img/05.11fd654f.png";